import React, { useEffect, useRef, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { TabPanel, TabView } from "primereact/tabview";
import { Toast } from "primereact/toast";
import { formatDate, formatDateTime, formatDateTimeSeconds } from "../../config/Config";
import { votersService } from "../../services/VotersService";
import { applicationsService } from "../../services/ApplicationsService";
import { Tooltip } from "primereact/tooltip";
import GenericViewApplication from "../applications/GenericViewApplication";
import { APPLICATION_TYPE_AMENDMENT, APPLICATION_TYPE_REGISTRATION, APPLICATION_TYPE_SUSPENSION, APPLICATION_TYPE_TRANSFER } from "../../constants";
import DelimitationView from "../applications/DelimitationView";
import { changeLang } from "../../componets/Language/ChangeLang";

export const VoterDialog = ({ voter, visible, onHide, loading, setLoading }) => {
	const toast = useRef(null);
	const [notitication, setNotitication] = useState([]);
	const [application, setApplication] = useState(null);

	useEffect(() => {
		if (voter !== null) {
			applicationsService.getNotificationsByID(voter?.applicationID).then((res) => {
				setNotitication(res);
			});

			setApplication(voter.application);
		}
	}, [voter]);

	const header = (name) => (
		<div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
			<h5 className="m-0">
				<b>{name}</b>
			</h5>
		</div>
	);

	function VoterDetails() {
		var cellphone1;
		var cellphone2;
		var email = "";

		if (voter && voter.contactDetails) {
			for (const contact of voter?.contactDetails) {
				if (contact.contactType.contactTypeID === 2) {
					email = contact.contactDetail;
				} else {
					if (contact.contactIndex === 1) {
						cellphone1 = `${contact?.countryCode?.code || ""}${contact?.contactDetail}`;
					} else {
						cellphone2 = `${contact?.countryCode?.code || ""}${contact.contactDetail}`;
					}
				}
			}
		}

		var inelegibilityReasons = "";
		if (voter?.ineligibilityDetails) {
			inelegibilityReasons = voter?.ineligibilityDetails
				.filter((detail) => detail.dateEffected == voter?.application.updatedDate)
				.map((detail) => detail.ineligibilityReason)
				.join(", ");
		}



		var obj = [
			{
				col1: "National ID:",
				col2: voter?.idNumber,
				col3: "Registration Number:",
				col4: voter?.registrationNumber
			},
			[null].includes(voter?.oldRegistrationNumber) ? null : {
				col1: "Old Registration Number:",
				col2: voter?.oldRegistrationNumber,
				col3: "",
				col4: ""

			},
			{
				col1: "Surname:",
				col2: voter?.surname,
				col3: "Firstname:",
				col4: voter?.firstname
			},
			{
				col1: "Date Of Birth:",
				col2: formatDate(voter?.dateOfBirth?.split(" ")[0]),
				col3: "Gender:",
				col4: voter?.gender
			},
			{
				col1: "Disability",
				col2: voter?.disability,
				col3: "Email:",
				col4: email
			},
			{
				col1: "Cellphone(1):",
				col2: cellphone1,
				col3: "Cellphone(2):",
				col4: cellphone2
			},
			{
				col1: "Eligibility Status:",
				col2: voter?.eligibleStatus == "Y" ? "Eligible" : "Not Eligible",
				col3: "Ineligibility Reason(s):",
				col4: voter?.ineligibilityReason
			},
			{
				col1: "Deceased:",
				col2: voter?.deceased == "Y" ? "Yes" : "No",
				col3: "",
				col4: ""
			}
		];

		return obj.filter(e => ![e].includes(null))
	}

	function ChannelDetails() {
		return [
			{
				col1: "Channel:",
				col2: voter?.application?.applicationChannel,
				col3: "Registration Number:",
				col4: voter?.registrationNumber
			},
			{
				col1: "Date Captured:",
				col2: formatDateTimeSeconds(voter?.createdDate),
				col3: "Date Registered:",
				col4: formatDateTimeSeconds(voter?.dateRegistered)
			}
		];
	}

	function RegistrationDetails() {
		return [
			{
				col1: `${changeLang.get("national_delimitation.level1District")}:`,
				col2: voter?.village?.district,
				col3: `${changeLang.get("national_delimitation.level2ConstituencyCouncil")}:`,
				col4: voter?.village?.constituency
			},
			{
				col1: `${changeLang.get("national_delimitation.level4RegistrationCentre")}:`,
				col2: voter?.village?.registrationCentre,
				col3: `${changeLang.get("national_delimitation.level5Village")}:`,
				col4: voter?.village?.name
			}
		];
	}

	function VotersDetailsTable({ data = [], header = "" }) {
		return (
			<DataTable
				className="remove-border"
				header={header}
				size="small"
				scrollable={true}
				value={data}
				dataKey="id"
				responsiveLayout="scroll"
				style={{ width: "100%" }}
			>
				<Column field="col1" style={{ width: "250px" }} body={(e) => <b>{e.col1}</b>}></Column>
				<Column field="col2" style={{ width: "250px" }}></Column>
				<Column field="col3" style={{ width: "250px" }} body={(e) => <b>{e.col3}</b>}></Column>
				<Column field="col4"></Column>
			</DataTable>
		);
	}

	return (
		<div className="grid">
			<div className="col-12">
				<Toast ref={toast} />
				<Dialog
					header={<h6>{`Elector Details -  ${voter?.surname}, ${voter?.firstname}  (${voter?.idNumber})`}</h6>}
					draggable={false}
					visible={visible}
					style={{ width: "95%", height: "95vh" }}
					modal
					onHide={(e) => {
						onHide();
					}}
				>
					<TabView>
						<TabPanel header="Elector">
							<VotersDetailsTable header={header("Elector Details")} data={VoterDetails()} />
							<br />
							<DelimitationView header="Demarcation" village={voter?.village} />
							<br />
							<VotersDetailsTable header={header("Registration Channel")} data={ChannelDetails()} />
						</TabPanel>
						<TabPanel header="Application">
							{/* <RegistrationView /> */}
							<GenericViewApplication
								setLoading={setLoading}
								loading={loading}
								applicationID={voter.applicationID}
								idNumber={voter.idNumber}
								myVoter={null}
							/>

							{/* {application && application?.applicationTypeID == APPLICATION_TYPE_REGISTRATION && <RegistrationView />}
							{application && application?.applicationTypeID == APPLICATION_TYPE_TRANSFER && <TransferView />}
							{application && application?.applicationTypeID == APPLICATION_TYPE_AMENDMENT && <AmendmentView />}
							<NotificationView /> */}
						</TabPanel>
					</TabView>
				</Dialog>
			</div>
		</div>
	);
};
